

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) =>
({
  container: {},
  sectionTitle: {
    marginBottom: theme.spacing(4),
  },
}));

export interface SimplePsleCandidateDetailProps {
  name: string;
  id: string;
  hypyName: string;
  indexNo: string;
  schoolName: string;
  examCode: string;
}

const SimplePsleCandidateDetail = ({
  name,
  hypyName,
  id,
  indexNo,
  schoolName,
  examCode,
}: SimplePsleCandidateDetailProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Typography className={classes.sectionTitle} variant="h3">
        {t('components->>SimpleCandidateDetail.Candidate Details')}
      </Typography>
      <Grid container>
        <Grid md={6} xs={12}>
          {hypyName ? (
            <KeyValue
              id="candidateName"
              keyText={t('components->>SimpleCandidateDetail.Candidate Name')}
              valueText={[name, `(${hypyName})`]}
            />
          ) : (
            <KeyValue
              id="candidateName"
              keyText={t('components->>SimpleCandidateDetail.Candidate Name')}
              valueText={name}
            />
          )}
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue
            id="indexNo"
            keyText={t('components->>SimpleCandidateDetail.Index No.')}
            valueText={indexNo}
          />
        </Grid>

        <Grid md={6} xs={12}>
          {examCode === 'PSLE' ? (
            <KeyValue
              id="schoolName"
              keyText={t('components->>SimpleCandidateDetail.SchoolName')}
              valueText={schoolName}
            />
          ) : (
            <KeyValue
              id="schoolName"
              keyText={t('components->>SimpleCandidateDetail.ExamCentre')}
              valueText={schoolName}
            />
          )}
        </Grid>
        <Grid md={6} xs={12}>
          {examCode === 'PSLE' && (
            <KeyValue
              id="nricFinPassport"
              keyText={t('components->>SimpleCandidateDetail.NRIC/FIN/Passport No.')}
              valueText={id}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SimplePsleCandidateDetail;
